<template>
  <div class="time wishlist-button">
    <div class="vl" @click="addToWishlist" v-if="!isFavoriteCourse">
      <font-awesome-icon icon="heart"></font-awesome-icon>
      <!--      <p>Add to Wishlist</p>-->
    </div>
    <div
      class="vl"
      @click="removeFromWishlist"
      v-else
      title="Remove From Wishlist"
    >
      <font-awesome-icon icon="heart" color="red"></font-awesome-icon>
    </div>
  </div>
</template>

<script>
import { customerApi } from "../../services/customerApi";
import { mapGetters } from "vuex";

export default {
  name: "wishlist-button",
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("user", ["getWishlist"])
  },
  data() {
    return {
      isFavoriteCourse: false
    };
  },
  methods: {
    addToWishlist() {
      if (this.isAuthenticated) {
        const courseData = {
          course_name: this.courseName,
          course_id: this.courseId
        };
        customerApi.addToWishlist(courseData).then(res => {
          customerApi.getWishlist();
          this.isFavoriteCourse = true;
          this.$bvToast.toast(`Added to Wishlist`, {
            autoHideDelay: 500,
            appendToast: true
          });
        });
      } else {
        this.$bvToast.toast(`Login To continue`, {
          autoHideDelay: 500,
          variant: "info",
          appendToast: true
        });
      }
    },
    removeFromWishlist() {
      const courseData = {
        course_name: this.courseName,
        course_id: this.courseId
      };
      customerApi.removeFromWishlist(courseData).then(res => {
        customerApi.getWishlist();
        this.isFavoriteCourse = false;
        this.$bvToast.toast(`Removed from  Wishlist`, {
          autoHideDelay: 500,
          variant: "danger",
          appendToast: true
        });
      });
    },
    isFavorite() {
      if(this.getWishlist.some(courseD => courseD.course_id === this.courseId)){
          this.isFavoriteCourse = true;
        }
    }
  },
  mounted() {
    if (this.isAuthenticated) {
      this.isFavorite();
    } else {
      this.isFavoriteCourse = false;
    }
  },
  props: {
    courseId: String,
    courseName: String
  },
  watch: {
    getWishlist() {
      if (this.isAuthenticated) {
        this.isFavorite();
      } else {
        this.isFavoriteCourse = false;
      }
    }
  }
};
</script>

<style scoped></style>
